import { useLocalStorageState } from '@frontend/common';
import { useEffect, useState } from 'react';

import { MobileDynamicOnboardScannerProps, ONBOARD_SCANNER_KEY } from './mobile-dynamic-onboard-scanner.component';

interface ViewProps {
    loading: boolean;
    onboardScanner: boolean;
}

const useMobileDynamicOnboardScanner = (props: MobileDynamicOnboardScannerProps): ViewProps => {
    const [loading, setLoading] = useState<boolean>(true);
    const [onboardScanner] = useLocalStorageState<boolean>(ONBOARD_SCANNER_KEY, false);

    /**
     * add one second of loading for the localstorage variable to be fully loaded
     * might not seem necessary, but it is very important
     */
    useEffect(() => {
        setTimeout(() => {
            setLoading(false);
        }, 1000);
    }, []);

    return { loading, onboardScanner };
};

export default useMobileDynamicOnboardScanner;
